"use strict";

function BrandLogo() {

}
angular
    .module("harriApp")
    .component("brandLogo", {
        controller: BrandLogo,
        bindings:{
            shape: '@',
            src: '<',
            sizing: '@',
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/shared/components/brand-logo/brand-logo.component.ng.html',
    });